import { IChargePoint } from '../../common/hooks/useChargePoint'

export default function canUpdateChargePoint(chargePoint: IChargePoint): boolean {
    return chargePoint.isOcpp ? chargePoint.chargePointStatus !== 'Offline' : true
}
